/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrefilledPairingBody
 */
export interface PrefilledPairingBody {
    /**
     * 
     * @type {string}
     * @memberof PrefilledPairingBody
     */
    name: string;
}

/**
 * Check if a given object implements the PrefilledPairingBody interface.
 */
export function instanceOfPrefilledPairingBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PrefilledPairingBodyFromJSON(json: any): PrefilledPairingBody {
    return PrefilledPairingBodyFromJSONTyped(json, false);
}

export function PrefilledPairingBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrefilledPairingBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function PrefilledPairingBodyToJSON(value?: PrefilledPairingBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

